import React, { useState, useEffect } from "react";

// react-router components
import { Route, Routes } from "react-router-dom";

import { Helmet } from 'react-helmet'


// core components
import Footer from "../components/Footer";


// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";

import IllustrationLayout from "../components/LayoutContainers/IllustrationLayout";
import OthelloCookieConsent from "../componentsothello/OthelloCookieConsent";

import routes from "../routesAuthApps.js";

import bgImage from "../assets/images/illustrations/illustration-reset.jpg";
import register from "../assets/img/register.jpeg";
import login from "../assets/img/login.jpeg";
import lock from "../assets/img/lock.jpeg";
import error from "../assets/img/clint-mckoy.jpg";
import resetpass from "../assets/img/register.jpeg";
import reservas from "../assets/img/reserva3.jpg";


function LayoutAuthApps() {

    const [rememberMe, setRememberMe] = useState(false);

    const handleSetRememberMe = () => setRememberMe(!rememberMe);

    const [urlimage, setUrlImage] = useState("");

    const getRoutes = (allRoutes) => {
        return allRoutes.map((route) => {
            //si es un item collapse hacemos route de los hijos
            if (route.collapse)
                return getRoutes(route.collapse);

            //if (route.route) {
            //    return <Route path={route.path} element={route.component} key={route.key} />;                                
            //}

            if (route.route && route.component) {
                const Component = route.component;

                return (
                    <Route
                        path={route.path}
                        key={route.key}
                        element={<Component sethookimage={setUrlImage} />}
                    />
                );
            }


            return null;
        });
    }

    const getTitle = () => {
        if (window.location.pathname.indexOf("/authapps/register") !== -1)
            return "Crear Cuenta";
        else if (window.location.pathname.indexOf("/authapps/rememberpass") !== -1)
            return "Restablecer Password";
        else if (window.location.pathname.indexOf("/authapps/login") !== -1)
            return "Login Usuario";
        else if (window.location.pathname.indexOf("/authapps/lockscreen") !== -1)
            return "Lock Screen";
        else if (window.location.pathname.indexOf("/authapps/error") !== -1)
            return "";
        else if (window.location.pathname.indexOf("/authapps/peticiones") !== -1)
            return "Login Usuario";
        else
            return "";
    };

    const getDescripcion = () =>
    {
        if (window.location.pathname.indexOf("/authapps/register") !== -1)
            return "Introduzca sus datos para realizar el registro.";
        else if (window.location.pathname.indexOf("/authapps/rememberpass") !== -1)
            return "Introduzca la direccion de e-mail registrada en el sistema.";
        else if (window.location.pathname.indexOf("/authapps/login") !== -1)
            return "Introduce tus credenciales para acceder.";
        else if (window.location.pathname.indexOf("/authapps/lockscreen") !== -1)
            return "Page not found - Ooooups! Looks like you got lost.";
        else if (window.location.pathname.indexOf("/authapps/error") !== -1)
            return "";
        else if (window.location.pathname.indexOf("/authapps/peticiones") !== -1)
            return "Introduce tus credenciales para acceder.";
        else
            return "";
    };

    const getBgImage = () => {

        if (urlimage != null && urlimage != "") {
            return urlimage;
        }
        else {
            if (window.location.pathname.indexOf("/authapps/register") !== -1)
                return register;
            else if (window.location.pathname.indexOf("/authapps/rememberpass") !== -1)
                return register;
            else if (window.location.pathname.indexOf("/authapps/loginapp") !== -1)
                return login;
            else if (window.location.pathname.indexOf("/authapps/loginreservas") !== -1)
                return reservas;
            else if (window.location.pathname.indexOf("/authapps/error") !== -1)
                return error;
        }
    };    
   

    let image = getBgImage();

    return (
        <IllustrationLayout
            title={getTitle()}
            description={getDescripcion()}
            illustration={image}>
            <Helmet>
                <title>Bienvenido a ATMovilidad Mobile Apps</title>
            </Helmet>
            <Routes>
                {getRoutes(routes)}
            </Routes>
            <MDBox mt={4}>
                <Footer />
            </MDBox>
            <OthelloCookieConsent />
        </IllustrationLayout>
    );
}

export default LayoutAuthApps;